import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type FilterItemProps = {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  onExpand?: () => void;
};

export default function FilterItem({
  title,
  children,
  defaultExpanded,
  onExpand,
}: FilterItemProps) {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{
        border: 'none',
        boxShadow: 'none',
        py: 0.75,
        '&.MuiAccordion-root': {
          '&:before': {
            display: 'none',
          },
        },
      }}
      onChange={(e, exp) => exp && onExpand && onExpand()}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon color="secondary" />}
        aria-controls="panel1-content"
      >
        <Box
          sx={{
            fontSize: '18px',
          }}
        >
          {title}
        </Box>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}
